{
  "loading": "読み込み中...",
  "loadingMore": "さらに読み込み中..."
}
